"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortDirection = void 0;
exports.getSortDirectionIcon = getSortDirectionIcon;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var sortDown = function sortDown(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M12.409 27.425a2.002 2.002 0 0 1-2.83 0l-7.997-8a1.992 1.992 0 0 1-.431-2.181A2 2 0 0 1 3 16.006h15.993a2.007 2.007 0 0 1 1.418 3.419l-7.997 8h-.006Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#00abc4",
    fillOpacity: ".8",
    d: "M12.409 27.425a2.002 2.002 0 0 1-2.83 0l-7.997-8a1.992 1.992 0 0 1-.431-2.181A2 2 0 0 1 3 16.006h15.993a2.007 2.007 0 0 1 1.418 3.419l-7.997 8h-.006Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M12.409.588a2.002 2.002 0 0 0-2.83 0l-7.997 8a1.992 1.992 0 0 0-.431 2.18A2 2 0 0 0 3 12.007h15.993a2.007 2.007 0 0 0 1.418-3.418l-7.997-8h-.006Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#00abc4",
    fillOpacity: ".4",
    d: "M12.409.588a2.002 2.002 0 0 0-2.83 0l-7.997 8a1.992 1.992 0 0 0-.431 2.18A2 2 0 0 0 3 12.007h15.993a2.007 2.007 0 0 0 1.418-3.418l-7.997-8h-.006Z"
  }));
};
sortDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 29",
  'aria-hidden': "true"
};
var sortUp = function sortUp(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M12.409 27.425a2.002 2.002 0 0 1-2.83 0l-7.997-8a1.992 1.992 0 0 1-.431-2.181A2 2 0 0 1 3 16.006h15.993a2.007 2.007 0 0 1 1.418 3.419l-7.997 8h-.006Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#00abc4",
    fillOpacity: ".4",
    d: "M12.409 27.425a2.002 2.002 0 0 1-2.83 0l-7.997-8a1.992 1.992 0 0 1-.431-2.181A2 2 0 0 1 3 16.006h15.993a2.007 2.007 0 0 1 1.418 3.419l-7.997 8h-.006Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M12.409.588a2.002 2.002 0 0 0-2.83 0l-7.997 8a1.992 1.992 0 0 0-.431 2.18A2 2 0 0 0 3 12.007h15.993a2.007 2.007 0 0 0 1.418-3.418l-7.997-8h-.006Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#00abc4",
    fillOpacity: ".8",
    d: "M12.409.588a2.002 2.002 0 0 0-2.83 0l-7.997 8a1.992 1.992 0 0 0-.431 2.18A2 2 0 0 0 3 12.007h15.993a2.007 2.007 0 0 0 1.418-3.418l-7.997-8h-.006Z"
  }));
};
sortUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 29",
  'aria-hidden': "true"
};
var sortNone = function sortNone(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M12.409 27.425a2.002 2.002 0 0 1-2.83 0l-7.997-8a1.992 1.992 0 0 1-.431-2.181A2 2 0 0 1 3 16.006h15.993a2.007 2.007 0 0 1 1.418 3.419l-7.997 8h-.006Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#00abc4",
    fillOpacity: ".4",
    d: "M12.409 27.425a2.002 2.002 0 0 1-2.83 0l-7.997-8a1.992 1.992 0 0 1-.431-2.181A2 2 0 0 1 3 16.006h15.993a2.007 2.007 0 0 1 1.418 3.419l-7.997 8h-.006Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M12.409.588a2.002 2.002 0 0 0-2.83 0l-7.997 8a1.992 1.992 0 0 0-.431 2.18A2 2 0 0 0 3 12.007h15.993a2.007 2.007 0 0 0 1.418-3.418l-7.997-8h-.006Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#00abc4",
    fillOpacity: ".4",
    d: "M12.409.588a2.002 2.002 0 0 0-2.83 0l-7.997 8a1.992 1.992 0 0 0-.431 2.18A2 2 0 0 0 3 12.007h15.993a2.007 2.007 0 0 0 1.418-3.418l-7.997-8h-.006Z"
  }));
};
sortNone.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 29",
  'aria-hidden': "true"
};
let SortDirection = exports.SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection["ASCENDING"] = "asc";
  SortDirection["DESCENDING"] = "desc";
  SortDirection["NONE"] = "none";
  return SortDirection;
}({});
const sortDirectionIcons = {
  [SortDirection.ASCENDING]: sortUp,
  [SortDirection.DESCENDING]: sortDown,
  [SortDirection.NONE]: sortNone
};
function getSortDirectionIcon(sortDirection) {
  return sortDirectionIcons[sortDirection];
}